import React from 'react';
import PropTypes from 'prop-types';


const ProgressBar = ({ percent, style }) => (
  <div className="progress-bar" style={{ ...style }}>
    <div style={{ width: `${percent}%` }} />
  </div>
);

ProgressBar.propTypes = {
  percent: PropTypes.number,
  style: PropTypes.object,
};

ProgressBar.defaultProps = {
  percent: 0,
  style: {},
};

export default ProgressBar;



// WEBPACK FOOTER //
// ./src/components/Playlist/ProgressBar.js